import { useRequestMutation } from "hooks/useRequest";
import { Chat, Reference } from "models/AiResearch";
import { convertKeysDeepToLowerCamel } from "utils/helper/convertNamingConvention";

// 過去のチャット表示用
export const useHistoryChat = ({
  setResult
}: {
  setResult: React.Dispatch<React.SetStateAction<Chat>>;
}) => {
  const { trigger } = useRequestMutation<
    {
      talkId: string;
      title: string;
      talkHistorys: {
        question: string;
        answer: string;
        questionDate: string;
      }[];
    },
    { talkId: string }
  >("/sse/query/rag/history", "GET", {
    onSuccess: data => {
      setResult({
        talkId: data.talkId,
        title: data.title,
        history: data.talkHistorys.map(item => {
          const parsedAnswer = JSON.parse(item.answer);
          const convertedAnswer = (convertKeysDeepToLowerCamel(
            parsedAnswer
          ) as unknown) as {
            ids: {
              questionId: string;
              answerId: string;
            }[];
            message?: string[];
            citationSource: Reference[];
            questionAssistance?: string[];
            relatedQuestions?: { questions: string[] }[];
            error?: {
              systemMessage: string;
              userMessage: string;
            }[];
          };

          // エラーメッセージの優先順位: 1. userMessage 2. 回答が空の場合のエラーメッセージ
          // 2.は以下の「LLM-PF想定外エラー（システム・インフラ等）」の内容
          // https://docs.google.com/spreadsheets/d/1MNs7QLYV_0zdlFIClr6xG0BpzeQsm2sZfIU_G215CcA/edit?usp=sharing
          const userErrorMessage =
            convertedAnswer.error?.[0]?.userMessage || null;
          // 回答が空かどうかの判定
          const isEmptyAnswer =
            !convertedAnswer.message || convertedAnswer.message.length === 0;

          return {
            question: item.question,
            answer: userErrorMessage
              ? userErrorMessage
              : isEmptyAnswer
              ? "回答の生成中にエラーが発生しました。\nしばらく時間をおいてから再度お試しください。"
              : convertedAnswer.message?.join("") || "",
            reference: convertedAnswer.citationSource,
            questionAt: item.questionDate,
            questionOptimization: convertedAnswer.questionAssistance?.[0] || "",
            relatedQuestions:
              convertedAnswer.relatedQuestions?.slice(-1)[0].questions || [],
            ids: convertedAnswer.ids[0],
            isError: convertedAnswer.error !== undefined || isEmptyAnswer,
            visibleRetryButton: isEmptyAnswer,
            sseStatus: "closed"
          };
        })
      });
    },
    onError: (error: unknown) => {
      const errorData = error as {
        data: {
          details: {
            apiErrorCode: string;
            message: string;
          }[];
        };
      };
      // W1140: 過去のチャットの取得に失敗（例：チャット履歴が存在しない、など）
      if (errorData.data?.details?.[0]?.apiErrorCode === "W1140") {
        setResult({
          talkId: "",
          hideChatForm: true, // チャットフォームを非表示にするフラグを追加
          title: "",
          history: []
        });
      }
    }
  });

  return { fetchHistoryChat: trigger };
};
